import i18n from '@Lang'

const IndicatorOperatorList = [{
  dataType: 'String',
  operateOptionList: [{
    code: 'eq',
    name: i18n.t('public.connector4'),
    inputType: 'MultiSelect'
  }, {
    code: 'ne',
    name: i18n.t('public.connector3'),
    inputType: 'MultiSelect'
  }, {
    code: 'contains',
    name: i18n.t('public.connector15'),
    inputType: 'Input'
  }, {
    code: 'left_contains',
    name: i18n.t('public.connector7'),
    inputType: 'Input'
  }, {
    code: 'right_contains',
    name: i18n.t('public.connector16'),
    inputType: 'Input'
  }, {
    code: 'not_contains',
    name: i18n.t('public.connector17'),
    inputType: 'Input'
  }, {
    code: 'is_not_empty',
    name: i18n.t('public.connector8'),
    inputType: ''
  }, {
    code: 'is_empty',
    name: i18n.t('public.connector9'),
    inputType: ''
  }, {
    code: 'is_null',
    name: i18n.t('public.connector2'),
    inputType: ''
  }, {
    code: 'is_not_null',
    name: i18n.t('public.connector1'),
    inputType: ''
  }]
}, {
  dataType: 'Number',
  operateOptionList: [{
    code: 'eq',
    name: i18n.t('public.connector4'),
    inputType: 'MultiSelect'
  }, {
    code: 'ne',
    name: i18n.t('public.connector3'),
    inputType: 'MultiSelect'
  }, {
    code: 'is_not_empty',
    name: i18n.t('public.connector8'),
    inputType: ''
  }, {
    code: 'is_empty',
    name: i18n.t('public.connector9'),
    inputType: ''
  }, {
    code: 'gt',
    name: i18n.t('public.connector5'),
    inputType: 'Number'
  }, {
    code: 'lt',
    name: i18n.t('public.connector6'),
    inputType: 'Number'
  }, {
    code: 'range',
    name: i18n.t('public.connector10'),
    inputType: 'Number'
  }]
}, {
  dataType: 'Date',
  operateOptionList: [{
    code: 'eq',
    name: i18n.t('public.connector4'),
    inputType: 'DatePicker'
  }, {
    code: 'ne',
    name: i18n.t('public.connector3'),
    inputType: 'DatePicker'
  }, {
    code: 'gt',
    name: i18n.t('public.connector5'),
    inputType: 'DatePicker'
  }, {
    code: 'ge',
    name: i18n.t('public.connector11'),
    inputType: 'DatePicker'
  }, {
    code: 'lt',
    name: i18n.t('public.connector6'),
    inputType: 'DatePicker'
  }, {
    code: 'le',
    name: i18n.t('public.connector12'),
    inputType: 'DatePicker'
  }, {
    code: 'range',
    name: i18n.t('public.connector10'),
    inputType: 'DatePicker'
  }]
}, {
  dataType: 'Datetime',
  operateOptionList: [{
    code: 'eq',
    name: i18n.t('public.connector4'),
    inputType: 'DateTimePicker'
  }, {
    code: 'ne',
    name: i18n.t('public.connector3'),
    inputType: 'DateTimePicker'
  }, {
    code: 'gt',
    name: i18n.t('public.connector5'),
    inputType: 'DateTimePicker'
  }, {
    code: 'ge',
    name: i18n.t('public.connector11'),
    inputType: 'DateTimePicker'
  }, {
    code: 'lt',
    name: i18n.t('public.connector6'),
    inputType: 'DateTimePicker'
  }, {
    code: 'le',
    name: i18n.t('public.connector12'),
    inputType: 'DateTimePicker'
  }, {
    code: 'range',
    name: i18n.t('public.connector10'),
    inputType: 'DateTimePicker'
  }]
}, {
  dataType: 'Boolean',
  operateOptionList: [{
    code: 'is_true',
    name: i18n.t('public.connector13'),
    inputType: ''
  }, {
    code: 'is_false',
    name: i18n.t('public.connector14'),
    inputType: ''
  }]
}, {
  dataType: 'IP',
  operateOptionList: [{
    code: 'eq',
    name: i18n.t('public.connector4'),
    inputType: 'MultiSelect'
  }, {
    code: 'ne',
    name: i18n.t('public.connector3'),
    inputType: 'MultiSelect'
  }, {
    code: 'gt',
    name: i18n.t('public.connector5'),
    inputType: 'Input'
  }, {
    code: 'ge',
    name: i18n.t('public.connector11'),
    inputType: 'Input'
  }, {
    code: 'lt',
    name: i18n.t('public.connector6'),
    inputType: 'Input'
  }, {
    code: 'le',
    name: i18n.t('public.connector12'),
    inputType: 'Input'
  }, {
    code: 'range',
    name: i18n.t('public.connector10'),
    inputType: 'Input'
  }]
}]

export {
  IndicatorOperatorList
}
